
import infoTextDatasets from '@/../static/json/hilfe_texte.json';


const infoTextDatasetsCache = {};


const defaultDataset = {
	variant: 'info',
	title: 'Info',
};


const resolvePropPathAccess = (propPath, obj) => {
	const splitPropPath = propPath.split('.')
	                              .map(prop => prop.trim())
	                              .filter(prop => prop.length > 0);

	if (splitPropPath.length === 0) {
		return false;
	}

	const nextProp = splitPropPath.shift();

	if (obj[nextProp]) {
		if (splitPropPath.length > 0) {
			return resolvePropPathAccess(splitPropPath.join('.'), obj[nextProp]);
		}

		return obj[nextProp];
	}

	return false;
};

const forFunc = (key, replacements = {}) => {
	const cleanedKey = key.trim();
	const cacheKey = `${cleanedKey}-${(replacements && JSON.stringify(replacements)) || ''}`;

	if (infoTextDatasetsCache[cacheKey]) {
		return infoTextDatasetsCache[cacheKey];
	}

	const infoTextDataset = resolvePropPathAccess(cleanedKey, infoTextDatasets);

	const resolvedInfoTextDataset = (infoTextDataset && infoTextDataset.text) ?
		Object.assign({}, defaultDataset, infoTextDataset) :
		null;

	infoTextDatasetsCache[cacheKey] = resolvedInfoTextDataset;

	if (infoTextDatasetsCache[cacheKey] && Object.keys(replacements).length > 0) {
		resolvedInfoTextDataset.text = resolvedInfoTextDataset.text.replace(
			/\{\{\s*(.*?)\s*\}\}/g,
			(firstMatch, matchKey) => {
				if (matchKey in replacements && replacements[matchKey]) {
					return Array.isArray(replacements[matchKey])
						? replacements[matchKey].join(' und ')
						: replacements[matchKey];
				}

				return firstMatch;
			},
		);
	}

	return infoTextDatasetsCache[cacheKey];
};


export default {
	for: forFunc,
	existsFor: (key => !!forFunc(key)),
};



// WEBPACK FOOTER //
// ./src/helper/infoTextHelper.js